export enum CsgCorner {
	EDGE = 'edge',
	CHAMFER = 'chamfer',
	ROUND = 'round',
}
export const CSG_CORNERS: CsgCorner[] = [CsgCorner.EDGE, CsgCorner.CHAMFER, CsgCorner.ROUND];
